import React from 'react';
import * as S from './MessageBody.styled';
export const MessageBody = ({ preview }) => {
    if (!preview) {
        return null;
    }
    return (React.createElement(S.Wrapper, null,
        React.createElement("div", { dangerouslySetInnerHTML: { __html: preview } })));
};
